import React from 'react';
import * as S from './ToastContainer.styled';
import 'react-toastify/dist/ReactToastify.css';
import { useNotDesktop } from 'context/Breakpoint';

export const ToastContainer = () => {
    const isNotDesktop = useNotDesktop();

    return (
        <S.Wrapper>
            <S.Container
                position={isNotDesktop ? 'bottom-center' : 'top-right'}
            />
        </S.Wrapper>
    );
};
